import { useEffect, useState, useCallback, useRef } from "react";

import { Term } from "../bitmaker/schemas/Billing/Term";

import { useApiError } from "./useApiError";

import { BitmakerAPIClient } from "../services/BitmakerApp";

export const useTerms = () => {
  const [terms, setTerms] = useState<Term[]>([]);
  const [loadingTerms, setLoadingTerms] = useState(false);
  const [fetchTermsError, setFetchTermsError] = useState<string | null>(null);

  const { handleAPIError } = useApiError();
  const isMountedRef = useRef(false);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const fetchTerms = useCallback(() => {
    if (!isMountedRef.current) return;

    setLoadingTerms(true);
    setFetchTermsError(null);

    BitmakerAPIClient.get("/billing/settings/terms", null, (response) => {
      if (!isMountedRef.current) return;

      const { isError, message } = handleAPIError(response);

      if (isError) {
        console.error("Error fetching terms:", message);
        setFetchTermsError("Error fetching terms. Please try again.");
        setLoadingTerms(false);
        return;
      }

      const data = Array.isArray(response.data) ? response.data : [];
      setTerms(data);

      setLoadingTerms(false);
    });
  }, [handleAPIError]);

  useEffect(() => {
    fetchTerms();
  }, [fetchTerms]);

  return {
    terms,
    loadingTerms,
    fetchTermsError,
    refetchTerms: fetchTerms,
  };
};
